import { baseUrl } from "../../../boot/index";
import axios from "axios";

// Add price list
export const addPriceList = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/create-price-list`, formData, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};

// update price list
export const updatePriceList = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/finance/app/v1/update-price-list/${formData.ROWID}`, formData, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};

// delete price list
export const deletePriceList = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/finance/app/v1/delete-price-list/${formData}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    console.log({ error });
    throw error;
  }
};
